angular.module('iqxCore')
.controller('actionDialogMakeContactEventCtrl', function ($scope, FormSvc, ApplicationSvc, ApiSvc) {
  $scope.selects={}
	$scope.selects.classcode=[]
	$scope.selects.outcome=[]
	$scope.selects.contacts=[]
	$scope.selects.acceptDeclineReason=[]
	$scope.theRecord={}
	$scope.callback={}

  FormSvc.setOptions($scope,{})

  $scope.validateSelect=function($select){
    if ($select.length == 0) {
  		return false
  	} else {
  		return $select
  	}
	}

  $scope.makeContactEvent=function(){
    var newData={}

    newData.pEventDate=moment().format('DD/MM/YYYY')+" "+moment($scope.theRecord.contacttime).format('HH:mm:ss')

    if ($scope.callback.date) {
      newData.pCallbackDate=moment($scope.callback.date).format('DD/MM/YYYY')+" "+moment($scope.callback.time).format('HH:mm:ss')
    }

    newData.pClassCode=$scope.selects.classcode.Value
    newData.pDescription=$scope.theRecord.description
    newData.pNotes=$scope.theRecord.notes
    newData.pOutcome=$scope.selects.outcome.Descrip
    newData.pAction='N'

    switch($scope.actiondialogparams.type.toLowerCase() ){
      case 'person':
          newData.pPersonID=$scope.actiondialogparams.linkID
      break

      case 'contact':
          newData.pEmploymentID=$scope.actiondialogparams.linkID
      break

      case 'company':
          newData.pEmploymentID=$scope.selects.contacts.Value
      break

      case 'vacancy':
          newData.pVacancyID=$scope.actiondialogparams.linkID
      break
    }

    if ($scope.actiondialogparams.type=="Company" && $scope.validateSelect($scope.selects.contacts) ==false) {
      FormSvc.alert('Error',"You need to select a contact.","error")
      return false
    }

    if ($scope.validateSelect($scope.selects.classcode) ==false) {
      FormSvc.alert('Error',"You need to select a Event Type.","error")
      return false
    }
    return $scope.exec('call/NetOwnerContactEventsSet',newData)
    .then(function(returnVal){
      if (returnVal) {
        FormSvc.alert("Contact Event Saved", "Your contact event was saved successfully", "success")
        $scope.selects.classcode=[]
        $scope.selects.outcome=[]
        $scope.selects.companyContacts=[]
        $scope.contacts=[]
        delete $scope.theRecord.notes
        $scope.theRecord.callbacktime=undefined
        $scope.theRecord.callbackdate=undefined
        delete $scope.theRecord.description
      }
    })
    .catch(function (err) {
      if (err && err!="escape key press") {ApplicationSvc.showMessage('Error',err,true)}
    })
  }

  $scope.getContactEventDetials=function(){

    $scope.theRecord.contactdate=moment().toDate()
    $scope.theRecord.contacttime=moment().toDate()

    if ($scope.actiondialogparams.type=="Company") {
      $scope.fetch({
        fetchAPI:'callresult/NetOwnerContactList?pCompanyID='+$scope.actiondialogparams.linkID,
        fetchTarget:'companyContacts',
        multiRow:true
      })
    }

    $scope.fetch({
      fetchAPI:'callresult/NetOwnerGetContactEventType',
      fetchTarget:'contactEventTypes',
      multiRow:true
    })

    $scope.fetch({
      fetchAPI:'callresult/NetOwnerGetContactEventOutcome',
      fetchTarget:'contactEventOutcomes',
      multiRow:true
    })
  }

  $scope.outcomeChanged=function($item){
    if (!$item.callback) {
      $item.callback=0
    }
    $scope.callback.date=moment().add($item.callback, 'days').toDate()
    $scope.callback.time=angular.copy($scope.callback.date)
  }

  $scope.getContactEventDetials()

})
